// extracted by mini-css-extract-plugin
module.exports = {"features":"Features_features__1zS0-","header":"Features_header__1mRXe","grid":"Features_grid__3u4xV","card":"Features_card__3-wWW","icon":"Features_icon__Wmas4"};